// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__2Wojm","Logo":"Toolbar_Logo__1Qs4F","TabletOnlyPlus":"Toolbar_TabletOnlyPlus__39xzA"};